export const STANDARD_DATE_FORMAT = 'dd/MM/yyyy';
export const STANDARD_DATE_TIME_FORMAT = 'dd/MM/yyyy hh:mm aaa';
export const ISO_DATE = 'yyyy-MM-dd';
export const SHORT_DATE = 'MMM dd, yyyy';
export const SHORT_MONTH_DATE = 'dd MMM yyyy';
export const LONG_MONTH_DATE = 'dd MMMM yyyy';
